class AnalyticsService {
  static incrementClicksSent () {
    this.clicksSent = this.clicksSent || 0;
    this.clicksSent += 1;
    return this.clicksSent;
  }

  static incrementSearchesSent () {
    this.searchesSent = this.searchesSent || 0;
    this.searchesSent += 1;
    return this.searchesSent;
  }

  static initGa (ga) {
    if (typeof ga === 'undefined') return;
    this.gaDefined = true;
  }

  static sendGaEvent (str, eventData) {
    if (!this.gaDefined) return;
    window.ga('send', str, eventData);
  }

  static sendPageVisit (category, label) {
    this.sendGaEvent('event', {
      eventCategory: category,
      eventAction: 'Page Visit',
      eventLabel: label,
      eventValue: null,
    });
  }

  static sendClick (category, label) {
    this.sendGaEvent('event', {
      eventCategory: category,
      eventAction: 'Click',
      eventLabel: label,
      eventValue: this.incrementClicksSent(),
    });
  }

  static sendSearch(term, lat, lng) {
    this.sendGaEvent('event', {
      eventCategory: 'Find a Doctor',
      eventAction: 'Search',
      eventLabel: `[${term}] - [${lat}, ${lng}]`,
      eventValue: this.incrementSearchesSent(),
    });
  }
}

export default AnalyticsService;
